import { createAsyncThunk } from '@reduxjs/toolkit';

import clientService from './clientService';

export const getClientPaymentMethodsInfo = createAsyncThunk(
  'clients/getClientPaymentMethodsInfo',
  async (_, { rejectWithValue }) => {
    try {
      const response = await clientService.getPaymentMethodsInfo();
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
